/* Mesmerize · Work with us · mes-work-with-us.js (no dependencies)
   Accordion: one row open at a time (button aria-expanded + panel hidden). Desktop with a mouse (>=900px):
   a 180px preview of the hovered row follows the cursor, tilting -3deg..+3deg across the list's width, and hides
   over the open row. The list rect is read once per hover gesture (and again only after a scroll); transform
   writes are batched to one per animation frame. */
(function () {
  'use strict';
  var DESK = '(min-width: 900px) and (hover: hover) and (pointer: fine)';

  function init(root) {
    if (root.__mww) return;
    var list = root.querySelector('[data-list]');
    if (!list) return;
    var rows = Array.prototype.slice.call(list.querySelectorAll('[data-row]'));
    var prev = list.querySelector('[data-prev]');
    var prevImg = prev && prev.querySelector('[data-prev-img]');
    var desk = window.matchMedia(DESK);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var st = { open: -1, hov: -1, rect: null, x: 0, y: 0, raf: 0 };

    rows.forEach(function (r, i) { if (r.classList.contains('is-open')) st.open = i; });

    function setOpen(i) {
      st.open = i;
      rows.forEach(function (r, j) {
        var on = j === i, b = r.querySelector('[data-btn]'), p = r.querySelector('[data-panel]');
        r.classList.toggle('is-open', on);
        if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (p) p.hidden = !on;
      });
      paint();
    }

    function onScroll() { st.rect = null; }
    function paint() {
      st.raf = 0;
      if (!prev) return;
      var show = desk.matches && st.hov >= 0 && st.hov !== st.open && !!rows[st.hov] && rows[st.hov].hasAttribute('data-prev-src');
      if (!show || !st.rect) { prev.style.opacity = '0'; return; }
      var w = st.rect.width, x = st.x, y = st.y;
      var tilt = reduce.matches ? 0 : (-3 + x / w * 6);
      prev.style.transform = 'translate(' + Math.min(w - 190, x + 28) + 'px,' + (y - 90) + 'px) rotate(' + tilt.toFixed(2) + 'deg)';
      prev.style.opacity = '1';
    }
    function queue() { if (!st.raf) st.raf = requestAnimationFrame(paint); }

    function onEnterList() {
      if (!prev || !desk.matches) return;
      st.rect = list.getBoundingClientRect();
      if (!st.warm) { /* first hover: warm the preview images (same URLs as the panels, so they share the cache) */
        st.warm = true;
        rows.forEach(function (r) { var s = r.getAttribute('data-prev-src'); if (s) { var im = new Image(); im.decoding = 'async'; im.src = s; } });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    function onMove(e) {
      if (!prev || !desk.matches) return;
      if (!st.rect) st.rect = list.getBoundingClientRect();
      st.x = e.clientX - st.rect.left; st.y = e.clientY - st.rect.top;
      queue();
    }
    function onLeave() {
      st.hov = -1; st.rect = null;
      window.removeEventListener('scroll', onScroll);
      if (prev) prev.style.opacity = '0';
    }

    rows.forEach(function (r, i) {
      var b = r.querySelector('[data-btn]');
      if (!b) return;
      b.addEventListener('click', function () { setOpen(st.open === i ? -1 : i); });
      b.addEventListener('mouseenter', function () {
        if (st.hov === i) return;
        st.hov = i;
        var src = r.getAttribute('data-prev-src');
        if (prevImg && src && prevImg.getAttribute('src') !== src) prevImg.setAttribute('src', src);
        queue();
      });
    });
    if (prev) {
      list.addEventListener('mouseenter', onEnterList);
      list.addEventListener('mousemove', onMove);
      list.addEventListener('mouseleave', onLeave);
    }

    root.__mww = {
      openRow: function (el) { var i = rows.indexOf(el); if (i >= 0 && i !== st.open) setOpen(i); },
      destroy: function () { window.removeEventListener('scroll', onScroll); if (st.raf) cancelAnimationFrame(st.raf); }
    };
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('.mww'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.mww'), function (r) { if (r.__mww) { r.__mww.destroy(); r.__mww = null; } });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var row = e.target && e.target.closest && e.target.closest('[data-row]');
    var root = row && row.closest('.mww');
    if (root && root.__mww) root.__mww.openRow(row);
  });
})();
